import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { Pais } from './pais.model';
import { catchError, Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaisService {

  urlPais: string = environment.apiBaseURL + '/Pais';
  urlPaisEstrangeiros: string = environment.apiBaseURL + '/PaisEstrangeiros';
  listPaises: Pais[] = [];
  listPaisEstrangeiros: Pais[] = [];
  constructor(private http: HttpClient) { }

  getPaises(lang: string): Observable<Pais[]> {
    return this.http.get<Pais[]>(this.urlPais + '?lang=' + lang).pipe(
      tap(res => {
        this.listPaises = res as Pais[];
      }),
      catchError(err => {
        console.error(err);
        return of([]);
      })
    );
  }

  getPaisesEstrangeiros(lang: string): Observable<Pais[]> {
    return this.http.get<Pais[]>(this.urlPaisEstrangeiros + '?lang=' + lang).pipe(
      tap(res => {
        this.listPaisEstrangeiros = res as Pais[];
      }),
      catchError(err => {
        console.error('Erro ao carregar paises:', err);
        return of([]);
      })
    );
  }
}
